class CustomFocus extends HTMLElement {
    constructor(){
        super();
        this.openButton = this.querySelector(this.getAttribute('open-button'));
        this.closeButton = this.querySelector(this.getAttribute('close-button'));
        this.accordions = Array.from(this.querySelectorAll('details.collapsable')) || [];
        this.modal = this.querySelector('dialog, .modal');
    }

    connectedCallback() {
        this.openButton.addEventListener('click', (event) => {
            event.preventDefault();
            this.openDialog();
        });
        this.closeButton.addEventListener('click', () => {
            this.closeDialog();
        });
        // Add event listener for when the modal loses focus
        this.modal.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                this.maintainFocus(this.modal, event);
            }
            if (event.key === 'Escape') {
                event.preventDefault();
                this.closeDialog();
            }
        });

        //Enable collapsable accordion
        if (this.accordions.length > 0) {
            this.collapsableAccordion();
        }
    }

    openDialog() {
        this.modal.classList.remove('tw-opacity-0');
        this.modal.showModal ? this.modal.showModal() : this.modal.classList.add('open');
        let overflowBody = document.querySelector('body');
        overflowBody.classList.add('tw-overflow-hidden');
        this.trapFocus(this.modal);
    }

    closeDialog(){
        let overflowBody = document.querySelector('body');
        overflowBody.classList.remove('tw-overflow-hidden');
        this.modal.classList.add('tw-opacity-0');
        this.modal.close ? this.modal.close() : this.modal.classList.remove('open');
        let fakeSelectOpen = this.querySelector('.fake-select-container.show-options');
        if (fakeSelectOpen) {
            fakeSelectOpen.classList.remove('show-options');
        }
    }

    trapFocus(modal) {
        const focusableElements = modal.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        modal.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                if (event.shiftKey) {
                    if (document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    }
                } else {
                    if (document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement.focus();
                    }
                }
            }
        });
        firstElement.focus();
    }
    maintainFocus(modal, event) {
        const focusableElements = modal.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
        const firstElement = focusableElements[0];
        const lastElement = focusableElements[focusableElements.length - 1];
        if (event.shiftKey && document.activeElement === firstElement) {
            event.preventDefault();
            lastElement.focus();
        } else if (!event.shiftKey && document.activeElement === lastElement) {
            event.preventDefault();
            firstElement.focus();
        }
    }

    collapsableAccordion() {
        this.accordions.forEach(accordion => {
            const handleToggle = () => {
                if (!accordion.open) return;
                this.accordions.forEach(otherAccordion => {
                    if (otherAccordion !== accordion && otherAccordion.open) {
                        otherAccordion.open = false;
                    }
                });
                accordion.open = true;
            };
            accordion.addEventListener('toggle', handleToggle);
        });
    }
}
customElements.define('custom-focus', CustomFocus);
